/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-08 08:52:25
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-01-15 13:54:50
 */
import React from 'react'
const FindNothing = () => {




    return (
        <div style={{width:'100%',height:'100%',alignItems:'center',display:'flex',justifyContent:'center'}}>
            <img  style={{alignItems:'center'}} src={require('../../../../../resources/img/emptyInfo.png')} />

        </div>
    );
}

export default FindNothing